import React from 'react'
import { FormattedHTMLMessage, Modal } from '@web/walter-ui-kit'
import { Details } from '../types'
import Content from './Content'
import { lang } from './lang'

interface Props {
    isOpen: boolean
    onClose: () => void
    details?: Details
}

function DetailsModal({ isOpen, onClose, details }: Props) {
    return (
        <Modal
            title={<FormattedHTMLMessage {...lang.title} />}
            onClose={onClose}
            isOpen={isOpen}
            dataPointer="details_modal"
            size="xs"
            withHeaderBorder
            type="dialog"
        >
            <Content details={details} onClose={onClose} />
        </Modal>
    )
}

export default DetailsModal
